import script from "./ModalConfirmacao.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalConfirmacao.vue?vue&type=script&setup=true&lang=js"

import "./ModalConfirmacao.vue?vue&type=style&index=0&id=0fa60a5e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fa60a5e"]])

export default __exports__